// import logo from "./logo.svg";
import "./App.css";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { gsap } from "gsap";
import Tile from "./component/Tile";
import Logo from "./images/logo.png";
import { Icon } from "@iconify/react";
import starLargeOutline from "@iconify/icons-healthicons/star-large-outline";
import personOutline from "@iconify/icons-healthicons/person-outline";
import awardTrophyOutline from "@iconify/icons-healthicons/award-trophy-outline";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// const tele = window.Telegram.WebApp;

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const newTheme = createTheme({
  typography: { fontFamily: ["IRANSansMobile"] },
  direction: "rtl",
  palette: {
    // primary: {
    //   main: "#fff",
    // },
    // action: {
    //   active: "#fff",
    //   hover: "#fff",
    //   selected: "#fff",
    //   disabled: "#fff",
    //   disabledBackground: "#fff",
    //   focus: "#fff",
    //   hoverOpacity: 0.08,
    //   disabledOpacity: 0.48,
    // },
    // secondary: {
    //   main: "#ebebeb",
    // },
    // danger: {
    //   main: "#fe2e4a",
    // },
    // live: {
    //   main: "#EA5C2B",
    // },
  },
});

function App() {
  // const [height, setHeight] = useState(0);
  const [tileHeight, setTileHeight] = useState(0);
  const [gameStoped, setGameStoped] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [resultList, setResultList] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  const [getInfoPage, setGetInfoPage] = useState(true);
  // const [nameValue, setNameValue] = useState("");
  // const [mobileValue, setMobileValue] = useState("");
  const [score, setScore] = useState(0);
  const [timeScale, setTimeScale] = useState(1);

  const ref = useRef(null);

  const t1 = useRef(null);
  const t2 = useRef(null);
  const t3 = useRef(null);
  const t4 = useRef(null);
  const t5 = useRef(null);

  const nameRef = useRef(null);
  const mobileRef = useRef(null);

  const tile1 = useRef(null);
  const tile2 = useRef(null);
  const tile3 = useRef(null);
  const tile4 = useRef(null);
  const tile5 = useRef(null);

  useEffect(() => {
    // try {
    //   tele.ready();
    //   tele.expand();
    //   console.log(tele.platform);
    // } catch (error) {
    //   console.log(error);
    // }
  }, []);

  useEffect(() => {
    if (getInfoPage) nameRef.current.focus();
  }, [getInfoPage]);

  useLayoutEffect(() => {
    let pHeight = ref.current.clientHeight;
    let eHeight = ref.current.clientHeight / 4;
    setTileHeight(eHeight);
    if (!t1.current)
      t1.current = new gsap.timeline({
        onRepeat: onRepeat,
        onRepeatParams: ["t1"],
        repeat: -1,
        paused: true,
      });
    if (!t2.current)
      t2.current = new gsap.timeline({
        onRepeat: onRepeat,
        onRepeatParams: ["t2"],
        repeat: -1,
        paused: true,
      });
    if (!t3.current)
      t3.current = new gsap.timeline({
        onRepeat: onRepeat,
        onRepeatParams: ["t3"],
        repeat: -1,
        paused: true,
      });
    if (!t4.current)
      t4.current = new gsap.timeline({
        onRepeat: onRepeat,
        onRepeatParams: ["t4"],
        repeat: -1,
        paused: true,
      });
    if (!t5.current)
      t5.current = new gsap.timeline({
        onRepeat: onRepeat,
        onRepeatParams: ["t5"],
        repeat: -1,
        paused: true,
      });
    t1.current.to("#tile1", {
      y: pHeight + eHeight,
      duration: 5,
      ease: "none",
    });

    t2.current.to("#tile2", {
      y: pHeight + eHeight,
      duration: 5,
      ease: "none",
    });
    t2.current.seek(1);

    t3.current.to("#tile3", {
      y: pHeight + eHeight,
      duration: 5,
      ease: "none",
    });
    t3.current.seek(2);

    t4.current.to("#tile4", {
      y: pHeight + eHeight,
      duration: 5,
      ease: "none",
    });
    t4.current.seek(3);

    t5.current.to("#tile5", {
      y: pHeight + eHeight,
      duration: 5,
      ease: "none",
    });
    t5.current.seek(4);
  }, []);

  const onRepeat = (e) => {
    switch (e) {
      case "t1": {
        tile1.current.randomPos();
        tile1.current.checkTile();

        break;
      }
      case "t2": {
        tile2.current.randomPos();
        tile2.current.checkTile();

        break;
      }
      case "t3": {
        tile3.current.randomPos();
        tile3.current.checkTile();
        break;
      }
      case "t4": {
        tile4.current.randomPos();
        tile4.current.checkTile();
        break;
      }
      case "t5": {
        tile5.current.randomPos();
        tile5.current.checkTile();
        break;
      }

      default:
        break;
    }
  };

  const onGameStart = () => {
    t1.current.play();
    t2.current.play();
    t3.current.play();
    t4.current.play();
    t5.current.play();
  };

  const stopGame = () => {
    // console.log("stop");
    t1.current.pause();
    t2.current.pause();
    t3.current.pause();
    t4.current.pause();
    t5.current.pause();
    setGameStoped(true);
    const timer = setInterval(() => {
      setShowResult(true);
      clearInterval(timer);
    }, 1000);
  };

  const onRetryClick = () => {
    resetGame();
  };

  const resetGame = (second) => {
    setGetInfoPage(false);
    setGameStoped(false);
    setShowResult(false);
    setScore(0);
    setTimeScale(1);

    let eHeight = ref.current.clientHeight / 4;
    setTileHeight(eHeight);

    t1.current.seek(0);

    t2.current.seek(1);

    t3.current.seek(2);

    t4.current.seek(3);

    t5.current.seek(4);

    tile1.current.randomPos();
    tile2.current.randomPos();
    tile3.current.randomPos();
    tile4.current.randomPos();
    tile5.current.randomPos();
  };

  // const onResetGame = () => {};

  const onStartGame = () => {
    // console.log("value 👉️", nameRef.current.value);
    if (nameRef.current.value && mobileRef.current.value) {
      resetGame();
    }
  };

  const increaseScore = () => {
    setTimeScale(timeScale + 0.05);
    console.log("timeScale: ", timeScale);
    setScore(score + 1);
  };

  useEffect(() => {
    t1.current.timeScale(timeScale);
    t2.current.timeScale(timeScale);
    t3.current.timeScale(timeScale);
    t4.current.timeScale(timeScale);
    t5.current.timeScale(timeScale);
  }, [timeScale]);

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={newTheme}>
        <div className="App" ref={ref} dir="rtl">
          <Tile
            ref={tile1}
            logo={Logo}
            id="tile1"
            tileHeight={tileHeight}
            stopGame={stopGame}
            gameStoped={gameStoped}
            increaseScore={increaseScore}
          />
          <Tile
            ref={tile2}
            logo={Logo}
            id="tile2"
            tileHeight={tileHeight}
            stopGame={stopGame}
            gameStoped={gameStoped}
            increaseScore={increaseScore}
          />
          <Tile
            ref={tile3}
            logo={Logo}
            id="tile3"
            tileHeight={tileHeight}
            stopGame={stopGame}
            gameStoped={gameStoped}
            increaseScore={increaseScore}
          />
          <Tile
            ref={tile4}
            logo={Logo}
            id="tile4"
            tileHeight={tileHeight}
            stopGame={stopGame}
            gameStoped={gameStoped}
            increaseScore={increaseScore}
          />
          <Tile
            ref={tile5}
            logo={Logo}
            id="tile5"
            tileHeight={tileHeight}
            onGameStart={onGameStart}
            gameStoped={gameStoped}
            stopGame={stopGame}
            increaseScore={increaseScore}
          />

          <div className="scoreBox">
            <div>امتیازات</div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                direction: "rtl",
                alignItems: "center",
                justifyContent: "center",
                // backgroundColor: "red",
              }}
            >
              <div style={{ margin: "10px 20px" }}>{score}</div>
              <Icon icon={starLargeOutline} width="40" height="40" />
            </div>
          </div>

          {showResult && (
            <div
              style={{
                width: "100%",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.85)",
                position: "absolute",
                left: "0",
                top: "0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="scoreBoard">
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Icon icon={awardTrophyOutline} width="120" height="120" />
                </div>
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "24px",
                  }}
                >
                  <div
                    style={{
                      flex: "1",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div>امتیاز شما</div>
                    <div
                      style={{
                        flex: "1",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ marginLeft: "20px" }}>{score}</div>
                      <Icon icon={starLargeOutline} width="50" height="50" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="resultHeader">
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Icon icon={starLargeOutline} width="28" height="28" />
                  <div style={{ marginRight: "8px" }}>رتبه</div>
                </div>
                <div
                  style={{
                    flex: "3",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Icon icon={personOutline} width="28" height="28" />
                  <div style={{ marginRight: "8px" }}>نام شرکت کننده</div>
                </div>
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Icon icon={awardTrophyOutline} width="28" height="28" />
                  <div style={{ marginRight: "8px" }}>امتیاز</div>
                </div>
              </div>

              {resultList.map((item, i) => {
                return (
                  <div
                    key={i}
                    className="resultRow"
                    style={{
                      borderBottom:
                        i < 9 ? "2px solid rgba(0, 0, 0, 0.4)" : "none",
                      borderRadius: i === 9 ? "0px 0px 25px 25px" : "0px",
                    }}
                  >
                    <div
                      style={{
                        flex: "1",
                        borderLeft: "2px solid rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {i + 1}
                    </div>
                    <div
                      style={{
                        flex: "3",
                        borderLeft: "2px solid rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    ></div>
                    <div
                      style={{
                        flex: "1",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    ></div>
                  </div>
                );
              })}

              <div
                style={{
                  width: "97%",
                  maxWidth: "768px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                  direction: "rtl",
                }}
              >
                <Button
                  variant="contained"
                  color="success"
                  style={{ width: "200px" }}
                  onClick={onRetryClick}
                >
                  بازی مجدد
                </Button>
                <div style={{ minWidth: "20px" }} />
                <Button
                  variant="contained"
                  className="resultbuttonstyle"
                  onClick={() => setGetInfoPage(true)}
                >
                  بازی جدید
                </Button>
              </div>
            </div>
          )}

          {getInfoPage && (
            <div
              style={{
                width: "100%",
                height: "100vh",
                background:
                  "linear-gradient(90deg,rgba(70, 70, 70, 1) 0%,rgba(100, 100, 100, 1) 25%,rgba(50, 50, 50, 1) 50%,rgba(100, 100, 100, 1) 75%,rgba(70, 70, 70, 1) 100%)",
                position: "absolute",
                left: "0",
                top: "0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "95vw",
                  maxWidth: "500px",
                  backgroundColor: "white",
                  borderRadius: "20px",
                  padding: "30px 20px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextField
                  label="نام و نام خانوادگی"
                  variant="outlined"
                  fullWidth
                  syle={{}}
                  inputProps={{
                    style: { direction: "ltr", textAlign: "right" },
                  }}
                  dir="ltr"
                  //   value={nameValue}
                  // onChange={(e)=>{setNameValue(e.target.value)}}
                  inputRef={nameRef}
                />
                <TextField
                  label="موبایل"
                  variant="outlined"
                  fullWidth
                  sx={{ mt: 2 }}
                  //   value={mobileValue}
                  // onChange={(e)=>{setMobileValue(e.target.value)}}
                  inputRef={mobileRef}
                  inputProps={{
                    maxLength: 11,
                    style: { textAlign: "start", direction: "ltr" },
                  }}
                />
                <Button
                  variant="contained"
                  color="success"
                  className="resultbuttonstyle"
                  sx={{ mt: 2 }}
                  onClick={onStartGame}
                >
                  شروع بازی
                </Button>
              </div>
            </div>
          )}
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}

export default App;
